module.exports = __webpack_public_path__ + "static/Partsee-logo.fa2c7ba8.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Partsee-logo.png
// module id = ./src/images/Partsee-logo.png
// module chunks = 4016850265702045000